export default "/fonts/Muli-ExtraLight.ttf?2062d6e596fa20db5dc8003cbd00331e";